import { render, staticRenderFns } from "./psOrder.vue?vue&type=template&id=06cdb263&"
import script from "./psOrder.vue?vue&type=script&lang=js&"
export * from "./psOrder.vue?vue&type=script&lang=js&"
import style0 from "./psOrder.vue?vue&type=style&index=0&id=06cdb263&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports